import validateJs from '../../../utils/validate';

const constraints = {
  id: {
    presence: { allowEmpty: false },
    length: {
      maximum: 32,
    },
    format: {
      pattern: /^[a-z0-9-]+$/,
      message: 'can only contain alphanumeric characters and dash.',
    },
  },
  name: {
    presence: { allowEmpty: false },
    length: {
      maximum: 128,
    },
  },
  email: {
    presence: { allowEmpty: false },
    email: true,
  },
  address: {
    presence: { allowEmpty: false },
  },
  projectUrl: {
    url: true,
  },
};

export const validate = (values) => {
  let errors = {};
  const result = validateJs.validate(values, constraints);
  if (result) {
    Object.keys(result).forEach((key) => {
      errors[key] = result[key][0];
    });
  }
  return errors;
};
